import { apiBaseUrl } from '../../../config/apiBaseUrl';
import { backendHost } from '../../../providers/apis/blogApi';

export const hasDbFlag = (value) => value === true || value === 1;

export const getBlogGraphic2Url = (id) => `${apiBaseUrl}/api/blogs/${id}/graphic2`;

export const getNewsGraphic2Url = (id) => `${apiBaseUrl}/api/news/${id}/graphic2`;

export const getPodcastGraphic2Url = (id) => `${apiBaseUrl}/api/podcasts/${id}/graphic2`;

export const getEventGraphic2Url = (id) => `${apiBaseUrl}/api/events/${id}/graphic2`;

export const resolveGraphic2Src = (
  id,
  hasGraphic2,
  graphic2Url,
  getUrl,
) => {
  if (!hasDbFlag(hasGraphic2)) return undefined;

  if (graphic2Url?.startsWith('http')) {
    return graphic2Url;
  }
  if (graphic2Url) {
    return `${apiBaseUrl}${graphic2Url}`;
  }
  if (id != null) {
    return getUrl(id);
  }
  return undefined;
};

export const resolveContentMedia = (row, getGraphic2Url) => {
  if (!hasDbFlag(row.hasGraphic2)) return '';
  const id = row.id ?? row.Id;
  if (id == null) return '';

  const version = row.LastUpdated || row.DateWritten || row.DatePublished;
  const base = getGraphic2Url(id);
  return version ? `${base}?v=${encodeURIComponent(version)}` : base;
};

export const getMediaDisplaySrc = (mediaPath) => {
  if (!mediaPath) return '';
  if (typeof mediaPath === 'string' && mediaPath.startsWith('http')) return mediaPath;
  if (typeof mediaPath === 'string' && mediaPath.startsWith('/api/')) {
    return `${apiBaseUrl}${mediaPath}`;
  }
  return `${backendHost}${mediaPath}`;
};
